import addError from '../../../utils/error.jsx';

export function request() {
    return {
        type: 'GET_MULTIPLES'
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'ERROR_MULTIPLES',
        errors
    };
}

export function finish(lines) {
    return {
        type: 'FINISH_MULTIPLES',
        lines
    };
}
